import {
  Feedback,
  FeedbackType,
  InteractionStatus,
  QuestionFeedback,
} from '@thiememeulenhoff/types';
import { ResultEntry } from '../interaction';

export type QuestionFeedbackFilterable = QuestionFeedback & {
  userIdentifier: string;
};

export function getTeacherFeedbackKey(
  contentPath: string,
  actor: string,
): string {
  return `${contentPath}::${actor}`;
}

function shouldShowArchivedMessage(
  result: ResultEntry | undefined,
  isSelfTest: boolean,
): result is ResultEntry & { lastArchivedAt: string } {
  return !!(
    result?.lastArchivedAt &&
    result.status === InteractionStatus.Empty &&
    !isSelfTest
  );
}

export function prependArchivedMessage({
  questionFeedbacks,
  result,
  isSelfTest,
  actor,
}: {
  questionFeedbacks: Array<QuestionFeedbackFilterable>;
  result: ResultEntry | undefined;
  isSelfTest: boolean;
  actor: string;
}): Array<QuestionFeedbackFilterable> {
  if (!shouldShowArchivedMessage(result, isSelfTest)) {
    return questionFeedbacks;
  }

  return [
    {
      id: 'last-archived-at',
      createdAt: result.lastArchivedAt,
      contentMessageType: 'refresh',
      header: 'assignment.feedback.deleted_result',
      message: '',
      type: FeedbackType.ASSIGNMENT_DELETION,
      userIdentifier: actor,
    },
    ...questionFeedbacks,
  ];
}

export function convertFeedbackToQuestionFeedback(
  feedbacks: Array<Feedback>,
): Array<QuestionFeedbackFilterable> {
  return feedbacks.map(
    (feedback) =>
      ({
        id: feedback.id ?? feedback.createdAt,
        createdAt: feedback.createdAt,
        contentMessageType: 'message',
        header: 'assignment.feedback.teacher_message',
        message: feedback.message,
        type: FeedbackType.TEACHER_FEEDBACK,
        userIdentifier: feedback.userReference || feedback.actor || '',
      }) satisfies QuestionFeedbackFilterable,
  );
}
